import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { KirjautunutTilintarkastajaService } from '../service/kirjautunut-tilintarkastaja.service'

@Injectable()
export class TilintarkastajaAuthGuard {
  constructor(
    private _router: Router,
    private _kirjautunutTilintarkastajaService: KirjautunutTilintarkastajaService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._kirjautunutTilintarkastajaService.tilintarkastajaObservable.pipe(
      map(tilintarkastajaTiedot => !!tilintarkastajaTiedot),
      tap(authenticated => {
        if (!authenticated) {
          this._router.navigate(['/'])
        }
      }),
    )
  }
}
